export interface Category {
  name: string;
  url: string;
  imageSeq: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20white%20sneakers%20with%20colorful%20accents%20scattered%20artistically%20on%20warm%20ivory%20linen%20surface%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20editorial%20product%20photography%2C%20modern%20minimalist%20composition%20with%20negative%20space%2C%20clean%20bright%20aesthetic&width=800&height=600&seq=cat-shoes-v2&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageSeq: 'cat-hoodies-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20pastel%20hoodie%20draped%20casually%20over%20rustic%20wooden%20stool%20on%20pale%20oatmeal%20backdrop%2C%20soft%20diffused%20afternoon%20light%2C%20editorial%20fashion%20photography%2C%20textured%20fabric%20details%20visible%2C%20warm%20minimal%20composition%2C%20cozy%20vibe&width=800&height=600&seq=cat-hoodies-v2&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    imageSeq: 'cat-tshirts-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20tee%20in%20terracotta%20and%20sage%20green%20neatly%20folded%20on%20light%20sand%20surface%2C%20natural%20window%20light%20from%20left%2C%20editorial%20product%20photography%2C%20clean%20minimal%20flat%20lay%2C%20fabric%20texture%20visible%2C%20modern%20apparel%20aesthetic&width=800&height=600&seq=cat-tshirts-v2&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    imageSeq: 'cat-jackets-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20leather%20jacket%20and%20denim%20jacket%20hung%20on%20minimal%20wooden%20rack%20against%20warm%20cream%20wall%2C%20soft%20studio%20lighting%20with%20subtle%20highlights%2C%20editorial%20fashion%20photography%2C%20clean%20composition%2C%20textured%20material%20detail&width=800&height=600&seq=cat-jackets-v2&orientation=landscape',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    imageSeq: 'cat-pants-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Casual%20linen%20trousers%20and%20tailored%20shorts%20laid%20flat%20on%20warm%20beige%20linen%2C%20gentle%20morning%20light%20streaming%20diagonally%2C%20editorial%20product%20photography%2C%20clean%20minimalist%20layout%2C%20fabric%20crease%20detail%2C%20modern%20summer%20style&width=800&height=600&seq=cat-pants-v2&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    imageSeq: 'cat-headwear-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20caps%20and%20bucket%20hats%20arranged%20in%20rainbow%20row%20on%20warm%20sand%20textured%20surface%2C%20overhead%20soft%20daylight%2C%20editorial%20flat%20lay%20photography%2C%20clean%20geometric%20composition%2C%20summer%20accessories%20vibe&width=800&height=600&seq=cat-headwear-v2&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    imageSeq: 'cat-sets-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20two%20piece%20outfit%20set%20displayed%20elegantly%20on%20pale%20oatmeal%20backdrop%2C%20warm%20golden%20hour%20light%2C%20editorial%20fashion%20photography%2C%20minimal%20mannequin%20display%2C%20harmonious%20color%20palette%2C%20lifestyle%20aesthetic&width=800&height=600&seq=cat-sets-v2&orientation=landscape',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    imageSeq: 'cat-underwear-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20basics%20neatly%20rolled%20and%20stacked%20on%20warm%20cream%20marble%20surface%2C%20soft%20studio%20lighting%20with%20gentle%20diffusion%2C%20editorial%20product%20photography%2C%20clean%20minimal%20composition%2C%20spa%20like%20serene%20atmosphere&width=800&height=600&seq=cat-underwear-v2&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    imageSeq: 'cat-jersey-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20with%20bold%20team%20colors%20hung%20on%20minimalist%20wooden%20hanger%20against%20warm%20ivory%20wall%2C%20dramatic%20side%20lighting%2C%20editorial%20sports%20photography%2C%20clean%20heroic%20composition%2C%20athletic%20energy&width=800&height=600&seq=cat-jersey-v2&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    imageSeq: 'cat-accessories-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20watch%20bracelets%20and%20sunglasses%20scattered%20artfully%20on%20pale%20blush%20velvet%20surface%2C%20soft%20natural%20light%20with%20catchlights%2C%20editorial%20luxury%20photography%2C%20clean%20curated%20composition%2C%20refined%20accessories%20flat%20lay&width=800&height=600&seq=cat-accessories-v2&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    imageSeq: 'cat-bags-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20tote%20bag%20and%20crossbody%20bag%20placed%20on%20warm%20honey%20wooden%20floor%2C%20soft%20morning%20light%20through%20sheer%20curtain%2C%20editorial%20fashion%20photography%2C%20clean%20elegant%20composition%2C%20leather%20texture%20visible%2C%20luxury%20minimal%20vibe&width=800&height=600&seq=cat-bags-v2&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    imageSeq: 'cat-belts-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Genuine%20leather%20belts%20in%20brown%20and%20black%20coiled%20elegantly%20on%20warm%20sand%20linen%2C%20soft%20directional%20lighting%20highlighting%20buckle%20details%2C%20editorial%20product%20photography%2C%20clean%20curated%20composition%2C%20craftsmanship%20aesthetic&width=800&height=600&seq=cat-belts-v2&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    imageSeq: 'cat-perfumes-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20fragrance%20bottles%20with%20golden%20accents%20displayed%20on%20warm%20cream%20travertine%20surface%2C%20soft%20backlighting%20creating%20halos%2C%20editorial%20beauty%20photography%2C%20elegant%20minimal%20composition%2C%20glass%20reflections%2C%20sophisticated%20perfume%20aesthetic&width=800&height=600&seq=cat-perfumes-v2&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    imageSeq: 'cat-other-v2',
    imageUrl: 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20items%20including%20water%20bottle%20and%20tech%20gadgets%20arranged%20on%20warm%20ivory%20surface%2C%20soft%20natural%20overhead%20light%2C%20editorial%20flat%20lay%20photography%2C%20clean%20organized%20composition%2C%20modern%20everyday%20essentials&width=800&height=600&seq=cat-other-v2&orientation=landscape',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';